import React from 'react';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';

export const GetErrorMessageIcon = () => {
  return (
    <FontAwesomeIcon
      iconClassName="FaExclamationCircle"
      iconContextProps={{
        className: 'ErrorMessageIcon mr-2',
      }}
    />
  );
};
